import React, { useEffect, useState } from "react";
import "./MultiSelectFilterPopup.css";
// import Button from "../button/Button";
import { useTranslation } from "react-i18next";
import type { TranslationKeys } from "../../../i18n";
import { Button } from "@mui/material";

export interface Option {
  id: string | number;
  name: string;
}

export interface MultiSelectFilterPopupProps {
  options: Option[];                           // ✅ supports id + name
  selectedOptions?: (string | number)[];       // pre-selected ids
  onApply: (selected: (string | number)[]) => void;
  onCancel: () => void;
}

const MultiSelectFilterPopup: React.FC<MultiSelectFilterPopupProps> = ({
  options,
  selectedOptions = [],
  onApply,
  onCancel,
}) => {
  const { t }: { t: (key: TranslationKeys) => string } = useTranslation();
  const [localSelected, setLocalSelected] = useState<(string | number)[]>([]);

  useEffect(() => {
    setLocalSelected(selectedOptions );
  }, [options, selectedOptions]);

  const toggleOption = (id: string | number) => {
    setLocalSelected((prev) =>
      prev.includes(id) ? prev.filter((o) => o !== id) : [...prev, id]
    );
  };

  return (
    <div className="filter-popup">
      <div className="options-list">
        {options.map((opt) => (
          <label key={opt.id} className="option-item">
            <input
              type="checkbox"
              checked={localSelected.includes(opt.id)}
              onChange={() => toggleOption(opt.id)}
            />
            {opt.name}
          </label>
        ))}
      </div>

      <div className="button-wrapper">
   
        <Button variant="outlined" onClick={onCancel} style={{marginRight: '8px'}}
           >{t("cancel")} </Button>
        <Button variant="contained" onClick={() => onApply(localSelected)}
            >{t("apply")}</Button>
        
      </div>
    </div>
  );
};

export default MultiSelectFilterPopup;
